import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityCombined} from '@/types/CapacityCombined';
import type {Employee} from '@/types/Employee';
import {apiUrl} from '@/utils/api';

type Props = {
    capacityYearMonth : string;
    employees : Employee[];
};

export const useGetCapacityCombined = (props : Props) : UseQueryResult<CapacityCombined[]> => {
    const fetch = useApiFetch();

    return useQuery(
        [
            'capacityCombined',
            `capacityCombined-${props.capacityYearMonth}`,
            ...props.employees.map(employee => employee.id.toString()),
        ],
        async ({signal}) => {
            const response = await fetch(
                apiUrl('/v1/capacity/capacity/combined').toString(),
                {
                    method: 'POST',
                    body: JSON.stringify({
                        capacityYearMonth: props.capacityYearMonth,
                        associateIDs: props.employees.map(employee => employee.id.toString()),
                    }),
                    signal,
                }
            );

            if (!response.ok) {
                throw new Error('Unable to fetch capacity combined.');
            }

            return await response.json() as CapacityCombined[];
        }
    );
};
